import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/showToaster';
import { createFooterSetting } from '../../../lib/graphql/admin/homePageSettings';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: createFooterSetting,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  showToaster({
    messageId: data?.CreateFooterSetting?.status === "success" ? 'footerSetting' : 'footerSettingError',
    toasterType: data?.CreateFooterSetting?.status === "success" ? 'success' : 'error'
  })

}

export default submit;